<!-- 省市区三级联动组件 -->
 
    <nz-cascader 
[(ngModel)]="values"
[nzLoadData]="loadData"
(ngModelChange)="onChanges($event)"
 
>
</nz-cascader>

 